import { Button, Divider, Form, Input } from 'antd';
import React, { ReactElement } from 'react';
import { useSelector } from 'react-redux';
import PasswordDescription from './PasswordDescription';
import { PasswordFormValue } from '../../custom_types/labels/label-profile-types';
import PasswordFormItems from './PasswordFormItems';
import { selectLoading } from '../../redux/Labels/LabelUserSlice';

interface PasswordPanelProps {
  isSelf: boolean;
  onSumbit: (values: PasswordFormValue) => void;
}

const PasswordPanel = ({
  isSelf,
  onSumbit
}: PasswordPanelProps): ReactElement => {
  const [form] = Form.useForm();
  const loading = useSelector(selectLoading);

  const passwordFormSubmitHandler = (values: PasswordFormValue) => {
    form.resetFields();
    onSumbit(values);
  };

  return (
    <Form
      form={form}
      className="form-body"
      onFinish={passwordFormSubmitHandler}
    >
      {isSelf && (
        <>
          {' '}
          <Form.Item
            name="password"
            label="账号密码"
            rules={[{ required: true, message: '请输入密码!' }]}
          >
            <Input.Password />
          </Form.Item>
          <Divider />{' '}
        </>
      )}
      <PasswordFormItems label="新的密码" showDescription={false} />
      <Form.Item name="description" label="密码要求">
        <PasswordDescription />
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit" loading={loading}>
          修改密码
        </Button>
      </Form.Item>
    </Form>
  );
};

export default PasswordPanel;
